// extracted by mini-css-extract-plugin
export var label = "_cq-1";
export var reminder = "_cq-0";